module.exports = __webpack_public_path__ + "static/bg-min-0e34d3917b674be62483505c86fa1f5b.jpg";